import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import CandidateRow from "./CandidateRow";
import RenderError from "./renderError";
import RenderLoading from "./renderLoading";

import { STATIC_STRINGS } from "@asez/shared";

import useCandidates from "./hooks/useCandidates";

const TablePaginationActions = ({ page, onPageChange, hasMore }) => {
  return (
    <div className="flex max-h-full">
      <IconButton
        onClick={() => onPageChange(null, page - 1)}
        disabled={page === 0}
      >
        <ArrowBack />
      </IconButton>
      <IconButton
        onClick={() => onPageChange(null, page + 1)}
        disabled={!hasMore}
      >
        <ArrowForward />
      </IconButton>
    </div>
  );
};

const CandidateTable = ({ hasMore }) => {
  const {
    error,
    page,
    isLoading,
    candidates,
    hasMoreItems,
    handlePageChange,
    handleDelete,
  } = useCandidates({ hasMore });

  if (error) {
    return <RenderError />;
  }

  return (
    <div className="mt-6 max-w-[900px] mx-auto text-base">
      <TableContainer>
        <Table stickyHeader sx={{ width: "100%", tableLayout: "fixed" }}>
          <TableHead
            sx={{
              backgroundColor: "var(--color-table-header)",
              "& .MuiTableCell-head": {
                backgroundColor: "var(--color-table-header)",
              },
            }}
          >
            <TableRow>
              <TableCell align="left" sx={{ width: "300px" }}>
                <span className="text-sm xl:text-base font-semibold">
                  {STATIC_STRINGS.CANDIDATE_NAME}
                </span>
              </TableCell>
              <TableCell align="center">
                <span className="text-sm xl:text-base font-semibold">
                  {STATIC_STRINGS.EMAIL}
                </span>
              </TableCell>
              <TableCell
                align="center"
                sx={{ minWidth: "150px", width: "150px", maxWidth: "150px" }}
              >
                <span className="text-sm xl:text-base font-semibold">
                  {STATIC_STRINGS.TABLE_HEADERS.ACTIONS}
                </span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <RenderLoading />
            ) : (
              <CandidateRow
                candidates={candidates}
                handleDelete={handleDelete}
              />
            )}
          </TableBody>
          <TableFooter
            sx={{
              backgroundColor: "var(--color-table-header)",
            }}
          >
            <TableRow>
              <TablePagination
                colSpan={3}
                rowsPerPageOptions={[]}
                count={
                  hasMoreItems
                    ? (page + 1) * 10 + 1
                    : page * 10 + candidates.length
                }
                rowsPerPage={10}
                page={page}
                onPageChange={handlePageChange}
                ActionsComponent={(props) => (
                  <TablePaginationActions {...props} hasMore={hasMoreItems} />
                )}
                labelDisplayedRows={({ from, to }) => {
                  const actualTo = Math.min(to, page * 10 + candidates.length);
                  return `${from} - ${actualTo}`;
                }}
                sx={{
                  "& .MuiTablePagination-displayedRows": {
                    fontSize: {
                      sm: "0.875rem",
                      xl: "1rem",
                    },
                  },
                }}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
};

export default CandidateTable;
